(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5354],{

/***/ 79792:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers/[id]",
      function () {
        return __webpack_require__(99852);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _id_; },
  "getCareers": function() { return /* binding */ getCareers; },
  "getPaths": function() { return /* binding */ getPaths; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(75833);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/apolloClient.ts
var apolloClient = __webpack_require__(94433);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
;// CONCATENATED MODULE: ./components/sections/RecruitmentProcess/recruitmentProcess.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 7.5rem;\n    padding-bottom: 8.75rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 4rem;\n    font-size: 3rem;\n    line-height: 3.5rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-rows: repeat(2, 1fr);\n    grid-template-columns: repeat(2, 1fr);\n    grid-row-gap: 4rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    grid-template-columns: repeat(4, 1fr);\n    grid-template-rows: 1fr;\n  "
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-right: 0;\n  "
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 2.5rem;\n    flex: 0 0 100%;\n  "
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
function _templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1rem;\n  "
    ]);
    _templateObject8 = function() {
        return data;
    };
    return data;
}
function _templateObject9() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    line-height: 2rem;\n  "
    ]);
    _templateObject9 = function() {
        return data;
    };
    return data;
}



const Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "esr2pn10"
})("padding-top:4rem;padding-bottom:4rem;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.light_grey;
}, ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())), ";");
const Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esr2pn11"
})(mixins/* defaultContainerSize */.sX, ";");
const Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "esr2pn12"
})("margin:0 0 2rem 0;font-size:2rem;line-height:2.5rem;font-weight:400;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), ";");
const Stages = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esr2pn13"
})("display:grid;grid-template-columns:1fr;grid-template-rows:repeat(4,1fr);grid-column-gap:4rem;grid-row-gap:2rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject4())), ";");
const Stage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esr2pn14"
})("display:flex;align-self:self-start;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject5())), ";");
const StageIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esr2pn15"
})("position:relative;height:4rem;width:4rem;margin-right:1rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject6())), ";");
const Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esr2pn16"
})(mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject7())), ";");
const Subtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h4", {
    target: "esr2pn17"
})("margin:0 0 0.25rem 0;font-weight:400;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";font-size:1.5rem;line-height:2rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject8())), ";");
const Description = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "esr2pn18"
})("margin:0;font-family:var(--font-second);font-weight:300;font-size:1rem;line-height:1.5rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject9())), ";");

;// CONCATENATED MODULE: ./components/sections/RecruitmentProcess/RecruitmentProcess.tsx





const RecruitmentProcess = (param)=>{
    let { title , items  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Inner, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stages, {
                    children: items.map((param)=>{
                        let { stage_icon , stage_title , stage_description  } = param;
                        const title = prismic_reactjs.RichText.asText(stage_title);
                        const description = prismic_reactjs.RichText.asText(stage_description);
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stage, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageIcon, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                        ...(0,imageSerializer/* imageSerializer */.l)(stage_icon)
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subtitle, {
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                                            children: description
                                        })
                                    ]
                                })
                            ]
                        }, title);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/RecruitmentProcess/index.ts

/* harmony default export */ var sections_RecruitmentProcess = (RecruitmentProcess);

// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
;// CONCATENATED MODULE: ./styles/pages/styled/career/career.styles.tsx

function career_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 2rem;\n    padding-bottom: 4rem;\n  "
    ]);
    career_styles_templateObject = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 2.5rem;\n    padding-bottom: 8.75rem;\n  "
    ]);
    career_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    font-size: 4rem;\n    line-height: 5rem;\n  "
    ]);
    career_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 0.5rem;\n    margin-bottom: 0;\n    flex: 0 0 auto;\n    order: 2;\n  "
    ]);
    career_styles_templateObject3 = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 auto;\n    order: 1;\n  "
    ]);
    career_styles_templateObject4 = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject5() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-left: 4rem;\n  "
    ]);
    career_styles_templateObject5 = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject6() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: inline-block;\n  "
    ]);
    career_styles_templateObject6 = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject7() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-width: 11rem;\n    width: auto;\n    padding: 0.75rem 3rem;\n  "
    ]);
    career_styles_templateObject7 = function() {
        return data;
    };
    return data;
}
function career_styles_templateObject8() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0.75rem 5rem;\n  "
    ]);
    career_styles_templateObject8 = function() {
        return data;
    };
    return data;
}




const career_styles_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etqf4qt0"
})("background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";");
const career_styles_Inner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "etqf4qt1"
})(mixins/* defaultContainerSize */.sX, ";padding-top:1.5rem;padding-bottom:5rem;position:relative;z-index:0;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject1())), ";");
const CareerContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etqf4qt2"
})("width:100%;margin:2rem 0 0 0;");
const CareerPosition = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h1", {
    target: "etqf4qt3"
})(Typography/* Headline1 */.iH, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject2())), ";");
const CareerDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "etqf4qt4"
})(Typography/* ParagraphS */.fw, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";display:flex;flex-wrap:wrap;margin:0;");
const CareerSalary = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "etqf4qt5"
})(Typography/* ParagraphM */.Sl, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";order:1;flex:0 0 100%;margin-bottom:1rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject3())), ";");
const CareerLocationWorkingHours = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "etqf4qt6"
})(Typography/* ParagraphS */.fw, ";order:2;flex:0 0 100%;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject4())), ";");
const CareerDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "etqf4qt7"
})("margin-top:2.5rem;position:relative;z-index:1;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject5())), ";");
const CareerParagraph = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "etqf4qt8"
})(Typography/* ParagraphM */.Sl, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.dark_grey;
}, ";max-width:48rem;margin:0;");
const CareerSubtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h2", {
    target: "etqf4qt9"
})(Typography/* Headline4 */.Ou, ";margin:3rem 0 1rem 0;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";");
const CareerList = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "etqf4qt10"
})("margin:0;padding-left:3.5rem;");
const CareerListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "etqf4qt11"
})(Typography/* ParagraphM */.Sl, ";color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";margin:0 0 1rem 0;&:last-of-type{margin-bottom:0;}");
const CareerApply = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "etqf4qt12"
})("color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";font-size:1.25rem;line-height:2rem;border:none;border-radius:4rem;text-align:center;box-shadow:none;position:relative;padding:0.75rem 0;font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";transition:background-color 300ms ease-in-out;text-decoration:none;display:block;margin-top:5rem;width:100%;", mixins/* boxShadow */.Wn, ";&:before{content:'';z-index:-1;width:100%;height:100%;position:absolute;left:0;top:0;border-radius:4rem;background:linear-gradient(67.33deg,#0e4ed7 -19.99%,#f94743 98.54%);}&:focus{outline:none;}&:hover{background-color:transparent;}", mixins.mq.xSmall((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject6())), ";", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject7())), ";", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(career_styles_templateObject8())), ";");

;// CONCATENATED MODULE: ./utils/htmlSerializers/careerHtmlSerializer.ts



const propsWithUniqueKey = (props, key)=>Object.assign(props || {}, {
        key
    });
// TODO: type of this function
const careerHtmlSerializer = (type, element, content, children, key)=>{
    let props = {};
    switch(type){
        case prismic_reactjs.Elements.paragraph:
            props = {};
            return react.createElement(CareerParagraph, propsWithUniqueKey(props, key), children);
        case prismic_reactjs.Elements.heading2:
            props = {};
            return react.createElement(CareerSubtitle, propsWithUniqueKey(props, key), children);
        case prismic_reactjs.Elements.list:
            props = {};
            return react.createElement(CareerList, propsWithUniqueKey(props, key), children);
        case prismic_reactjs.Elements.listItem:
            props = {};
            return react.createElement(CareerListItem, propsWithUniqueKey(props, key), children);
        default:
            return null;
    }
};

// EXTERNAL MODULE: ./graphql/queries/index.ts
var queries = __webpack_require__(96540);
// EXTERNAL MODULE: ./models/enums/routes.ts
var routes = __webpack_require__(20365);
// EXTERNAL MODULE: ./styledComponents/BackButton/BackButton.tsx + 2 modules
var BackButton = __webpack_require__(2029);
;// CONCATENATED MODULE: ./pages/careers/[id].tsx










const Career = (param)=>{
    let { data: { page: { career , recruitment  }  }  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(career_styles_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(career_styles_Inner, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BackButton/* default */.Z, {
                        color: "white",
                        url: routes/* Routes.Careers */.Z.Careers,
                        label: prismic_reactjs.RichText.asText(career.back_button)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CareerContent, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CareerPosition, {
                                children: prismic_reactjs.RichText.asText(career.position)
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CareerDetails, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CareerLocationWorkingHours, {
                                        children: [
                                            prismic_reactjs.RichText.asText(career.location),
                                            (career === null || career === void 0 ? void 0 : career.working_hours) ? " - " + prismic_reactjs.RichText.asText(career.working_hours) : ""
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CareerSalary, {
                                        children: prismic_reactjs.RichText.asText(career.salary)
                                    })
                                ]
                            }),
                            career.salary_per_hour && career.working_hours_freelance && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CareerDetails, {
                                style: {
                                    display: prismic_reactjs.RichText.asText(career.salary_per_hour).length > 0 ? "flex" : "none"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CareerLocationWorkingHours, {
                                        children: [
                                            prismic_reactjs.RichText.asText(career.location),
                                            " -",
                                            " ",
                                            prismic_reactjs.RichText.asText(career.working_hours_freelance)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CareerSalary, {
                                        children: prismic_reactjs.RichText.asText(career.salary_per_hour)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CareerDescription, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(prismic_reactjs.RichText, {
                                        render: career.description,
                                        htmlSerializer: careerHtmlSerializer
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CareerApply, {
                                        target: "_blank",
                                        href: career.apply_button_link.url || "",
                                        rel: "noreferrer",
                                        children: prismic_reactjs.RichText.asText(career.apply_button_label)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sections_RecruitmentProcess, {
                title: prismic_reactjs.RichText.asText(recruitment.title),
                items: recruitment.stages
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _id_ = (Career);
const getCareers = async (currentLanguage)=>{
    const response = await apolloClient/* apolloClient.query */.l8.query((0,apolloClient/* getPageQuery */.uH)({
        pageLang: currentLanguage
    }, "top_articles", queries/* SUMMARIZED_JOB_QUERY */.Pt));
    return response.data.allCareer_pages.edges;
};
const getPaths = async (currentLanguage)=>{
    const careers = await getCareers(currentLanguage);
    const paths = careers.map((job)=>prismic_reactjs.RichText.asText(job.node.seo_url)).map((path)=>({
            params: {
                id: path
            }
        }));
    return paths;
};


/***/ }),

/***/ 2029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BackButton_BackButton; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/svg/back-arrow.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 22,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M20.5 6H2m0 0 5-5M2 6l5 5"
  })));
};
/* harmony default export */ var back_arrow = (SvgBackArrow);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./styledComponents/BackButton/backButton.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n          svg {\n            path {\n              stroke: ",
        ";\n            }\n          }\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          background-color: ",
        ";\n          color: ",
        ";\n\n          path {\n            stroke: ",
        ";\n          }\n        "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}


const Button = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e11i2m5c0"
})("font-size:1.25rem;line-height:2rem;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.black;
}, ";font-family:", (param)=>{
    let { theme  } = param;
    return theme.font.questrial;
}, ";padding:0.5rem 1.5625rem;position:relative;text-decoration:none;box-shadow:inset 0 0 0 0.0625rem ", (param)=>{
    let { theme  } = param;
    return theme.colors.grey;
}, ";background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";border-radius:4rem;transition:background-color 200ms ease-in-out,box-shadow 200ms ease-in-out,color 200ms ease-in-out;margin-bottom:0;width:5rem;display:flex;justify-content:space-around;align-items:center;cursor:pointer;", (param)=>{
    let { colorType , theme  } = param;
    switch(colorType){
        case "white":
            {
                return (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), theme.colors.core_white, theme.colors.core_black);
            }
        case "black":
            {
                return (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), theme.colors.core_black, theme.colors.core_white, theme.colors.core_white);
            }
    }
}, "  &:before{content:'';z-index:-1;width:100%;height:100%;position:absolute;left:0;top:0;border-radius:4rem;background:linear-gradient(\n      88.48deg,#0f4ed7 0%,#684b9f 59.57%,#d2485c 98.61%\n    );}&:hover{background-color:transparent;box-shadow:none;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";path{stroke:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";}}svg{path{transition:stroke 200ms ease-in-out;}}");

;// CONCATENATED MODULE: ./styledComponents/BackButton/BackButton.tsx




const BackButton = (param)=>/*#__PURE__*/ {
    let { url , label , color  } = param;
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: url,
        legacyBehavior: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button, {
            colorType: color,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(back_arrow, {}),
                label
            ]
        })
    });
};
/* harmony default export */ var BackButton_BackButton = (BackButton);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8634,4433,9774,2888,179], function() { return __webpack_exec__(79792); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);